import React from 'react';
import { noop } from 'lodash';
import cn from 'classnames';
import { string, number, func, bool } from 'prop-types';
import classes from './index.module.scss';

const InputTag = ({
    tag,
    key,
    disabled,
    onRemove = noop,
    getTagDisplayValue,
    className,
    ...other
}) => {
    const displayValue = getTagDisplayValue(tag);

    return displayValue ? (
        <span key={key} className={cn(classes.tag, className)} {...other}>
            {displayValue}
            {!disabled && (
                <a
                    className={classes.tagRemove}
                    onClick={() => onRemove(key)}
                />
            )}
        </span>
    ) : null;
};

InputTag.propTypes = {
    tag: string,
    key: number,
    disabled: bool,
    onRemove: func,
    className: string,
    getTagDisplayValue: func,
};

export default InputTag;
